

// export var dayOrder = [
//     {
//         order : "1",
//         periods:["ASP","MCP","OS","MCP","DAA"]
//     },
//     {
//         order : "2",
//         periods:["LAB","LAB","LAB","OS","LIB"]
//     },
//     {
//         order : "3",
//         periods:["DAA","ASP","SS","SS","PHP"]
//     },
//     {
//         order : "4",
//         periods:["ASP","OS","MCP","DAA","OS"]
//     },
//     {
//         order : "5",
//         periods:["DAA","ASP","OS","ASP","PHP"]
//     },
//     {
//         order : "6",
//         periods:["LAB","LAB","LAB","DAA","MCP"]
//     }
// ]

// export var dayOrder = [
//     {
//         order : "1",
//         periods:["CG","DCN","SE","PY","GE"]
//     },
//     {
//         order : "2",
//         periods:["LAB","LAB","LAB","SE","SE"]
//     },
//     {
//         order : "3",
//         periods:["PY","DCN","PY","SE","SE"]
//     },
//     {
//         order : "4",
//         periods:["CG","SE","PY","CG","DCN"]
//     },
//     {
//         order : "5",
//         periods:["PY","PY","CG","DCN","DCN"]
//     },
//     {
//         order : "6",
//         periods:["CG","DCN","LAB","LAB","LAB"]
//     }
// ]


export var dayOrder = [
  {
      order : "1",
      periods:["CG","PY","SE","DCN","CG"]
  },
  {
      order : "2",
      periods:["CG","DCN","PY","SE","SE"]
  },
  {
      order : "3",
      periods:["LAB","LAB","LAB","SE","SE"]
  },
  {
      order : "4",
      periods:["CG","SE","GE","PY","DCN"]
  },
  {
      order : "5",
      periods:["PY","PY","CG","DCN","DCN"]
  },
  {
      order : "6",
      periods:["PY","DCN","LAB","LAB","LAB"]
  }
]


export var monthOrder = [
  [
    {
      "date": 1,
      "dayorder": 0
     },
     {
      "date": 2,
      "dayorder": 1
     },
     {
      "date": 3,
      "dayorder": 2
     },
     {
      "date": 4,
      "dayorder": 3
     },
     {
      "date": 5,
      "dayorder": 4
     },
     {
      "date": 6,
      "dayorder": 0
     },
     {
      "date": 7,
      "dayorder": 0
     },
     {
      "date": 8,
      "dayorder": 5
     },
     {
      "date": 9,
      "dayorder": 6
     },
     {
      "date": 10,
      "dayorder": 1
     },
     {
      "date": 11,
      "dayorder": 2
     },
     {
      "date": 12,
      "dayorder": 3
     },
     {
      "date": 13,
      "dayorder": 0
     },
     {
      "date": 14,
      "dayorder": 0,
      "holiday": "Pongal"
     },
     {
      "date": 15,
      "dayorder": 0,
      "holiday": "Pongal"
     },
     {
      "date": 16,
      "dayorder": 0,
      "holiday": "Pongal"
     },
     {
      "date": 17,
      "dayorder": 0
     },
     {
      "date": 18,
      "dayorder": 4
     },
     {
      "date": 19,
      "dayorder": 5
     },
     {
      "date": 20,
      "dayorder": 0
     },
     {
      "date": 21,
      "dayorder": 0
     },
     {
      "date": 22,
      "dayorder": 6
     },
     {
      "date": 23,
      "dayorder": 1
     },
     {
      "date": 24,
      "dayorder": 2
     },
     {
      "date": 25,
      "dayorder": 0
     },
     {
      "date": 26,
      "dayorder": 0
     },
     {
      "date": 27,
      "dayorder": 0
     },
     {
      "date": 28,
      "dayorder": 0
     },
     {
      "date": 29,
      "dayorder": 3
     },
     {
      "date": 30,
      "dayorder": 4
     },
     {
      "date": 31,
      "dayorder": 5
     }
     
  ],
  [ {
    "date": 1,
    "dayorder": 6
   },
   {
    "date": 2,
    "dayorder": 1
   },
   {
    "date": 3,
    "dayorder": 0
   },
   {
    "date": 4,
    "dayorder": 0
   },
   {
    "date": 5,
    "dayorder": 2
   },
   {
    "date": 6,
    "dayorder": 3
   },
   {
    "date": 7,
    "dayorder": 4
   },
   {
    "date": 8,
    "dayorder": 5
   },
   {
    "date": 9,
    "dayorder": 6
   },
   {
    "date": 10,
    "dayorder": 0
   },
   {
    "date": 11,
    "dayorder": 0
   },
   {
    "date": 12,
    "dayorder": 1
   },
   {
    "date": 13,
    "dayorder": 2
   },
   {
    "date": 14,
    "dayorder": 3
   },
   {
    "date": 15,
    "dayorder": 4
   },
   {
    "date": 16,
    "dayorder": 5
   },
   {
    "date": 17,
    "dayorder": 0
   },
   {
    "date": 18,
    "dayorder": 0
   },
   {
    "date": 19,
    "dayorder": 6
   },
   {
    "date": 20,
    "dayorder": 1
   },
   {
    "date": 21,
    "dayorder": 2
   },
   {
    "date": 22,
    "dayorder": 3
   },
   {
    "date": 23,
    "dayorder": 4
   },
   {
    "date": 24,
    "dayorder": 0
   },
   {
    "date": 25,
    "dayorder": 0
   },
   {
    "date": 26,
    "dayorder": 5
   },
   {
    "date": 27,
    "dayorder": 6
   },
   {
    "date": 28,
    "dayorder": 1
   },
   {
    "date": 29,
    "dayorder": 2
   }],
  [{
    "date": 1,
    "dayorder": 3
   },
   {
    "date": 2,
    "dayorder": 0
   },
   {
    "date": 3,
    "dayorder": 0
   },
   {
    "date": 4,
    "dayorder": 4
   },
   {
    "date": 5,
    "dayorder": 5
   },
   {
    "date": 6,
    "dayorder": 6
   },
   {
    "date": 7,
    "dayorder": 1
   },
   {
    "date": 8,
    "dayorder": 2
   },
   {
    "date": 9,
    "dayorder": 0
   },
   {
    "date": 10,
    "dayorder": 0
   },
   {
    "date": 11,
    "dayorder": 3
   },
   {
    "date": 12,
    "dayorder": 4
   },
   {
    "date": 13,
    "dayorder": 5
   },
   {
    "date": 14,
    "dayorder": 6
   },
   {
    "date": 15,
    "dayorder": 1
   },
   {
    "date": 16,
    "dayorder": 0
   },
   {
    "date": 17,
    "dayorder": 0
   },
   {
    "date": 18,
    "dayorder": 2
   },
   {
    "date": 19,
    "dayorder": 3
   },
   {
    "date": 20,
    "dayorder": 4
   },
   {
    "date": 21,
    "dayorder": 5
   },
   {
    "date": 22,
    "dayorder": 6
   },
   {
    "date": 23,
    "dayorder": 0
   },
   {
    "date": 24,
    "dayorder": 0
   },
   {
    "date": 25,
    "dayorder": 1
   },
   {
    "date": 26,
    "dayorder": 2
   },
   {
    "date": 27,
    "dayorder": 3
   },
   {
    "date": 28,
    "dayorder": 4
   },
   {
    "date": 29,
    "dayorder": 0,
    "holiday": "Good Friday"
   },
   {
    "date": 30,
    "dayorder": 0
   },
   {
    "date": 31,
    "dayorder": 0
   }],
  [ {
    "date": 1,
    "dayorder": 5
   },
   {
    "date": 2,
    "dayorder": 6
   },
   {
    "date": 3,
    "dayorder": 1
   },
   {
    "date": 4,
    "dayorder": 2
   },
   {
    "date": 5,
    "dayorder": 3
   },
   {
    "date": 6,
    "dayorder": 4
   },
   {
    "date": 7,
    "dayorder": 0
   },
   {
    "date": 8,
    "dayorder": 0,
    "holiday": "Extra "
   },
   {
    "date": 9,
    "dayorder": 0,
    "holiday": "Telugu New Year"
   },
   {
    "date": 10,
    "dayorder": 0,
    "holiday": "ramzan "
   },
   {
    "date": 11,
    "dayorder": 5
   },
   {
    "date": 12,
    "dayorder": 6
   },
   {
    "date": 13,
    "dayorder": 1
   },
   {
    "date": 14,
    "dayorder": 0
   },
   {
    "date": 15,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 16,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 17,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 18,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 19,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 20,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 21,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 22,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 23,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 24,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 25,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 26,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 27,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 28,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 29,
    "dayorder": 0,
    "holiday": "6th sem "
   },
   {
    "date": 30,
    "dayorder": 0,
    "holiday": "6th sem "
   }],
  [],
  [],
  [],
  [],
  [{
      date: 1,
      dayorder: 5
    },
    {
      date: 2,
      dayorder: 0
    },
    {
      date: 3,
      dayorder: 0
    },
    {
      date: 4,
      dayorder: 6
    },
    {
      date: 5,
      dayorder: 1
    },
    {
      date: 6,
      dayorder: 0,
      holiday: "Krishna Jayanthi"
    },
    {
      date: 7,
      dayorder: 2
    },
    {
      date: 8,
      dayorder: 3
    },
    {
      date: 9,
      dayorder: 0
    },
    {
      date: 10,
      dayorder: 0
    },
    {
      date: 11,
      dayorder: 4
    },
    {
      date: 12,
      dayorder: 5
    },
    {
      date: 13,
      dayorder: 6
    },
    {
      date: 14,
      dayorder: 1
    },
    {
      date: 15,
      dayorder: 2
    },
    {
      date: 16,
      dayorder: 0
    },
    {
      date: 17,
      dayorder: 0
    },
    {
      date: 18,
      dayorder: 3
    },
    {
      date: 19,
      dayorder: 0,
      holiday: "Vinayagar Chaturthi"
    },
    {
      date: 20,
      dayorder: 4
    },
    {
      date: 21,
      dayorder: 5
    },
    {
      date: 22,
      dayorder: 6
    },
    {
      date: 23,
      dayorder: 0
    },
    {
      date: 24,
      dayorder: 0
    },
    {
      date: 25,
      dayorder: 1
    },
    {
      date: 26,
      dayorder: 2
    },
    {
      date: 27,
      dayorder: 3
    },
    {
      date: 28,
      dayorder: 0,
      holiday: "Miladi Nabi"
    },
    {
      date: 29,
      dayorder: 4
    },
    {
      date: 30,
      dayorder: 0
    }
  ],
  [{
      date: 1,
      dayorder: 0
    },
    {
      date: 2,
      dayorder: 0,
      holiday: "Gandhi Jayanti"
    },
    {
      date: 3,
      dayorder: 5
    },
    {
      date: 4,
      dayorder: 6
    },
    {
      date: 5,
      dayorder: 1
    },
    {
      date: 6,
      dayorder: 2
    },
    {
      date: 7,
      dayorder: 0
    },
    {
      date: 8,
      dayorder: 0
    },
    {
      date: 9,
      dayorder: 3
    },
    {
      date: 10,
      dayorder: 4
    },
    {
      date: 11,
      dayorder: 5
    },
    {
      date: 12,
      dayorder: 6
    },
    {
      date: 13,
      dayorder: 1
    },
    {
      date: 14,
      dayorder: 0
    },
    {
      date: 15,
      dayorder: 0
    },
    {
      date: 16,
      dayorder: 2
    },
    {
      date: 17,
      dayorder: 3
    },
    {
      date: 18,
      dayorder: 4
    },
    {
      date: 19,
      dayorder: 5
    },
    {
      date: 20,
      dayorder: 6
    },
    {
      date: 21,
      dayorder: 0
    },
    {
      date: 22,
      dayorder: 0
    },
    {
      date: 23,
      dayorder: 0,
      holiday: "Ayudha Pooja "
    },
    {
      date: 24,
      dayorder: 0,
      holiday: "vijayadashami"
    },
    {
      date: 25,
      dayorder: 1
    },
    {
      date: 26,
      dayorder: 2
    },
    {
      date: 27,
      dayorder: 3
    },
    {
      date: 28,
      dayorder: 0
    },
    {
      date: 29,
      dayorder: 0
    },
    {
      date: 30,
      dayorder: 4
    },
    {
      date: 31,
      dayorder: 5
  }],
    [{
      date: 1,
      dayorder: 6
    },
    {
      date: 2,
      dayorder: 1
    },
    {
      date: 3,
      dayorder: 0
    },
    {
      date: 4,
      dayorder: 0
    },
    {
      date: 5,
      dayorder: 0
    },
    {
      date: 6,
      dayorder: 0,
      holiday: "Sem Starts"
    },
    {
      date: 7,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 8,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 9,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 10,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 11,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 12,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 13,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 14,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 15,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 16,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 17,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 18,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 19,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 20,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 21,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 22,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 23,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 24,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 25,
      dayorder: 0,
      holiday: "Sem going"
    },
    {
      date: 26,
      dayorder: 0,
      holiday: "Sem end"
    },
    {
      date: 27,
      dayorder: 0,
      holiday: "6th sem day order update soon"
    },
    {
      date: 28,
      dayorder: 0,
      holiday: "6th sem day order update soon"
    },
    {
      date: 29,
      dayorder: 0,
      holiday: "6th sem day order update soon"
    },
    {
      date: 30,
      dayorder: 0,
      holiday: "6th sem day order update soon"
    }],
    [
      {
        "date": 1,
        "dayorder": 5
       },
       {
        "date": 2,
        "dayorder": 0
       },
       {
        "date": 3,
        "dayorder": 0
       },
       {
        "date": 4,
        "dayorder": 4
       },
       {
        "date": 5,
        "dayorder": 1
       },
       {
        "date": 6,
        "dayorder": 2
       },
       {
        "date": 7,
        "dayorder": 3
       },
       {
        "date": 8,
        "dayorder": 4
       },
       {
        "date": 9,
        "dayorder": 0
       },
       {
        "date": 10,
        "dayorder": 0
       },
       {
        "date": 11,
        "dayorder": 5
       },
       {
        "date": 12,
        "dayorder": 6
       },
       {
        "date": 13,
        "dayorder": 1
       },
       {
        "date": 14,
        "dayorder": 2
       },
       {
        "date": 15,
        "dayorder": 3
       },
       {
        "date": 16,
        "dayorder": 0
       },
       {
        "date": 17,
        "dayorder": 0
       },
       {
        "date": 18,
        "dayorder": 4
       },
       {
        "date": 19,
        "dayorder": 5
       },
       {
        "date": 20,
        "dayorder": 6
       },
       {
        "date": 21,
        "dayorder": 1
       },
       {
        "date": 22,
        "dayorder": 2
       },
       {
        "date": 23,
        "dayorder": 1
       },
       {
        "date": 24,
        "dayorder": 0
       },
       {
        "date": 25,
        "dayorder": 0,
        "holiday": "Christmas"
       },
       {
        "date": 26,
        "dayorder": 3
       },
       {
        "date": 27,
        "dayorder": 4
       },
       {
        "date": 28,
        "dayorder": 5
       },
       {
        "date": 29,
        "dayorder": 6
       },
       {
        "date": 30,
        "dayorder": 0
       },
       {
        "date": 31,
        "dayorder": 0
       }
    ]

  ] 

